<script>
    import { onMount, tick } from "svelte";
    import Chart from 'chart.js/auto';
    import Gradient from '../../../services/gradient.js';
    import { truncateString } from "../../../js/utils.js";
    import { format } from "svelte-i18n";
    import { url } from "@roxi/routify";

    export let data = {};
    export let field = "value";
    export let filter = {};

    $url;

    let canvas;
    let chart;

    let dataCopy = JSON.parse(JSON.stringify(data));

    if(dataCopy.length >= 10){
        let otherResults = dataCopy.splice(9);
        let result = otherResults.reduce((accumulator, currentObject)=>{
            return accumulator + currentObject.count;
        }, 0);
        dataCopy.push({count: result, value: $format("others"), name: $format("others"), kind: $format("others")})
    }

    let gradientArray = new Gradient()
        //.setColorGradient("#B10c52", "#230B0C")
        .setColorGradient("#343a40","#3c8dbc") // opcion 1
        .setMidpoint(dataCopy.length <= 5 ? 5 : dataCopy.length)
        .getColors();
    ;
    for(let [index, color] of gradientArray.entries()){
        gradientArray[index] = color + "AE";
    }

    onMount(async () => {
        await tick();

        let context  = canvas.getContext('2d');

        let chartData = {
            labels   : [],
            datasets : {
                backgroundColor : gradientArray,
                data: [],
            },
        }

        for (const obj of dataCopy) {
            if(obj.value === "" || !obj.value) obj.value = "N/A";
            obj.value = truncateString(obj.value, 47)
            chartData.labels.push(obj.label ? obj.label : obj[field]);
            chartData.datasets.data.push(obj.count);
        }

        chart = new Chart(context, {
            type: 'doughnut',
            options: {
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide

                //clip: false,
                responsive: true,
                maintainAspectRatio: false,
                borderWidth: 1,
                //cutout: '50%',
                weight : 20,
                plugins:{
                    legend: {
                        //display: false,
                        //position: 'bottom',
                        position: 'right',
                        labels: {
                            font: {
                                fontFamily: 'Montserrat',
                                size: 14
                            }
                        }
                    },
                },
                title: {
                    display: false,
                },
                animation : {
                    animateScale: true,
                    animateRotate: true
                },
                onHover : (event) => {
                    canvas.style.cursor = "pointer";
                },
                onClick: (event)=> {
                    if(event.chart.tooltip.title[0] == $format("others")) return;
                    window.location.href = $url(`/property/finding/${encodeURIComponent(event.chart.tooltip.title[0])}`, filter)
                }
            },
            data : {
                labels  : chartData.labels,
                datasets: [chartData.datasets]
            },
        });
    });

</script>
<style>
    /*#chart-vuls-by-severity {
        height: 250px !important;
        margin: 0 auto;
        width: 808px;
    }*/
</style>
<canvas bind:this={canvas} id="chart-vuls-by-severity" class:chart-has-no-data="{data.length <= 0}" ></canvas>
